var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-box"},[_c('van-nav-bar',{attrs:{"title":"报名缴费","left-text":"返回","fixed":true,"left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }